import React from "react";
import PersonalDataStepShared from "../common/components/PersonalDataStep/PersonalDataStepShared";

/**
 * Room rental customer-data step. Thin wrapper over the shared, prop-gated
 * {@link PersonalDataStepShared} (issue #868): the room flow shows the company
 * field, the full address block and the "booking for myself / someone else"
 * radio group.
 */
const PersonalDataStep = () => (
  <PersonalDataStepShared showCompany showAddress showBookingForOptions />
);

export default PersonalDataStep;
